import moment from 'moment-timezone';
import { CreateANewPhonecallCommand } from 'src/stores/phoneCall/commands';

import { CreateANewPhonecallCommandResponse } from 'src/components/phoneCall/phoneCallGateway/InterfacesAndTypes';

import { CommandBus } from 'src/util/command/CommandBus';

export abstract class AbstractDirectPhoneCallGatewayStrategy {
	protected readonly commandBus: CommandBus;
	private readonly authenticatedUserId: number;

	protected constructor(commandBus: CommandBus, authenticatedUserId: number) {
		this.commandBus = commandBus;
		this.authenticatedUserId = authenticatedUserId;
	}

	protected async createPhoneCall(callerName: string, number: string): Promise<string> {
		const response = await this.commandBus.sendCommand<CreateANewPhonecallCommandResponse>(
			new CreateANewPhonecallCommand(
				moment(new Date()).tz('Europe/Berlin', false).unix(),
				0,
				callerName,
				number,
				'',
				this.authenticatedUserId,
				this.authenticatedUserId,
				false,
				1,
				0,
				[]
			)
		);

		return String(response?.data.data.phoneCallId);
	}
}
